import { StubErrorBoundary, StubPage } from '#app/components/stub-page.tsx'
import { type Route } from './+types/index.ts'

export const meta: Route.MetaFunction = () => [
	{ title: 'Live-kävijäseuranta — Frisbeegolfradat' },
]

export default function Index() {
	return (
		<StubPage
			eyebrow="Radat"
			title="Live-kävijäseuranta"
			intro="Näe reaaliaikainen kävijämäärä DiscGolfPark-radoilla."
		/>
	)
}

export { StubErrorBoundary as ErrorBoundary }
